<!-- 商品管理 V2 详情 - 产品监控 / 产品类型 / 禁发物流编辑弹窗 -->
<template>
  <el-dialog
    :title="mode === 'forbid' ? '编辑产品监控' : mode === 'supply' ? '编辑产品类型' : '编辑禁发物流'"
    :visible.sync="visible"
    width="600px"
    append-to-body
    destroy-on-close
  >
    <div v-loading="loading" class="monitor-edit-dialog">
      <!-- 违禁品类别（多选） -->
      <template v-if="mode === 'forbid'">
        <p class="field-title">违禁品类别</p>
        <el-checkbox-group v-model="selectedForbidTypes" class="option-list">
          <el-checkbox v-for="item in forbidTypeOptions" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </template>
      <!-- 禁发物流：物流 ID 多选 -->
      <template v-else-if="mode === 'logistics'">
        <p class="field-title">禁发物流</p>
        <el-checkbox-group v-model="selectedLogistics" class="option-list logistics-option-list">
          <el-checkbox v-for="item in logisticsOptions" :key="item.id" :label="Number(item.id)">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </template>
      <!-- 产品类型：现货 / OEM / ODM -->
      <template v-else>
        <p class="field-title">产品类型</p>
        <el-checkbox-group v-model="selectedSupplyTypes" class="option-list">
          <el-checkbox v-for="item in supplyTypeOptions" :key="item" :label="item">{{ item }}</el-checkbox>
        </el-checkbox-group>
      </template>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="mode === 'logistics'" @click="selectedLogistics = []">清空</el-button>
      <el-button type="primary" :disabled="loading" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
/**
 * 产品监控、产品类型与禁发物流编辑
 * 确认后通过对应事件回传父页
 */
export default {
  name: 'MonitorEditDialog',
  data() {
    return {
      visible: false,
      loading: false,
      mode: 'forbid', // forbid | supply | logistics
      forbidTypeOptions: [], // 违禁品选项（接口）
      supplyTypeOptions: ['现货', 'OEM', 'ODM'],
      logisticsOptions: [], // 物流方式选项（接口）
      selectedForbidTypes: [],
      selectedSupplyTypes: [],
      selectedLogistics: []
    }
  },
  methods: {
    // 打开违禁品编辑，拉取 forbidTypeOptions
    openForbid(selected) {
      this.mode = 'forbid'
      this.selectedForbidTypes = selected.slice()
      this.visible = true
      this.loading = true
      this.$api.productManagementApi.forbidTypeOptions({scope:'detail'}).then(res => {
        this.forbidTypeOptions = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    // 打开产品类型编辑
    openSupply(selected) {
      this.mode = 'supply'
      this.selectedSupplyTypes = selected.slice()
      this.visible = true
    },
    // 打开禁发物流编辑，拉取未删除的物流方式。
    openLogistics(selected) {
      this.mode = 'logistics'
      this.selectedLogistics = selected.map(id => Number(id))
      this.visible = true
      this.loading = true
      this.$api.siteConfiguration.logisticsList({ is_show: 1, is_delete: 0 }).then(res => {
        this.logisticsOptions = res.data
        this.selectedLogistics = this.selectedLogistics.filter(id => res.data.some(item => Number(item.id) === id))
      }).finally(() => {
        this.loading = false
      })
    },
    // 确认并回传选中值
    confirm() {
      if (this.mode === 'forbid') {
        const names = this.forbidTypeOptions
          .filter(item => this.selectedForbidTypes.includes(item.id))
          .map(item => item.name)
        this.$emit('confirm-forbid', {
          ids: this.selectedForbidTypes.map(id => Number(id)),
          names
        })
      } else if (this.mode === 'logistics') {
        const names = this.logisticsOptions
          .filter(item => this.selectedLogistics.includes(Number(item.id)))
          .map(item => item.name)
        this.$emit('confirm-logistics', {
          ids: this.selectedLogistics.slice(),
          names
        })
      } else {
        this.$emit('confirm-supply', this.selectedSupplyTypes.slice())
      }
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.monitor-edit-dialog {
  min-width: 0;
  min-height: 120px;
  overflow-x: hidden;
}
.field-title { margin: 0 0 18px; font-size: 15px; font-weight: 700; }
.option-list { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 18px 24px; }
.option-list .el-checkbox {
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
  margin: 0;
  white-space: normal;
  box-sizing: border-box;
}
// 长类别名称在所属网格内换行，避免撑出弹框。
.option-list /deep/ .el-checkbox__input {
  flex: none;
  margin-top: 3px;
}
.option-list /deep/ .el-checkbox__label {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 4px;
  line-height: 20px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.logistics-option-list { grid-template-columns: repeat(2, minmax(0, 1fr)); max-height: 360px; overflow-y: auto; }
.logistics-option-list .el-checkbox { white-space: normal; }
.dialog-footer { display: block; text-align: center; }
</style>
